import { render } from "./StudentSkillAssessmentDialog.vue?vue&type=template&id=85bc457c&scoped=true"
import script from "./StudentSkillAssessmentDialog.vue?vue&type=script&lang=js"
export * from "./StudentSkillAssessmentDialog.vue?vue&type=script&lang=js"

import "./StudentSkillAssessmentDialog.vue?vue&type=style&index=0&id=85bc457c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bc457c"]])

export default __exports__